export function hasTranslationText(row) {
  return Boolean(String(row?.originalText ?? '').trim());
}

export function translationHealth(row) {
  return hasTranslationText(row) ? 'present' : 'missing';
}

export function translationHealthLabel(row) {
  return hasTranslationText(row) ? 'Translation present' : 'Translation missing';
}
